import React from "react"
import styled from "@emotion/styled"

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding-top: 50px;
  border-left: 2px #c5c5c5 solid;
  border-right: 2px #c5c5c5 solid;
  background: white;
  padding-top: 80px;
  align-items: left;
`
const Template = ({ children }) => <Container>{children}</Container>

export default Template
